import { render, staticRenderFns } from "./RingChart.vue?vue&type=template&id=753901b4&"
import script from "./RingChart.vue?vue&type=script&lang=js&"
export * from "./RingChart.vue?vue&type=script&lang=js&"
import style0 from "./RingChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports